import { render, staticRenderFns } from "./newPaymentModel.vue?vue&type=template&id=3f262bca&scoped=true&"
import script from "./newPaymentModel.vue?vue&type=script&lang=js&"
export * from "./newPaymentModel.vue?vue&type=script&lang=js&"
import style0 from "./newPaymentModel.vue?vue&type=style&index=0&id=3f262bca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f262bca",
  null
  
)

export default component.exports